// const loadJS = require('../../viscomjs/load/LoadJs');
const adapters = require('./adapters');
import createjs from 'createjs';
export class CanvasInitAdapter {
    constructor() {
        this._scripts = [
            './js/viscom/mastercard/businesscards/canvas/createjs-2015.11.26.min.js',
            './js/viscom/mastercard/businesscards/canvas/main.js',
            './js/viscom/mastercard/businesscards/canvas/CanvasInit.js'
        ];
    }

    init() {
        /*
        const placeAnimation = anim => {
            const canvas = document.getElementById('canvas');
            const comp = anim;
            const lib = comp.getLibrary();
            const exportRoot = new lib[`0`]();
            const stage = new lib.Stage(canvas);

            function tick(event) {
                if (!anim.plays) {
                    stage.update(event);
                }
            }

            stage.addChild(exportRoot);
            createjs.Ticker.framerate = lib.properties.fps;
            createjs.Ticker.addEventListener('tick', tick);
        };
        function handleComplete(evt, animation) {
            const AdobeAn = animation.AdobeAn;
            const comp = animation.composition;
            const lib = comp.getLibrary();

            // This function is always called, irrespective of the content. You can use the variable "stage" after it is created in token create_stage.
            AdobeAn.compositionLoaded(lib.properties.id);

            const ss = comp.getSpriteSheet();
            const queue = evt.target;
            const ssMetadata = lib.ssMetadata;

            if (queue) {
                for (let i = 0; i < ssMetadata.length; i++) {
                    ss[ssMetadata[i].name] = new createjs.SpriteSheet({ images: [queue.getResult(ssMetadata[i].name)], frames: ssMetadata[i].frames });
                }
            }
            animation.loaded = true;
            placeAnimation(animation.composition);
        }
        function loadAnimationResources(animation, complete, ratio) {
            animation.loading = true;
            // let lib = animation.composition.getLibrary();
            ratio;
            // let lastProgress = 0;
            const loader = new createjs.LoadQueue(false);

            animation.loaded = true;
            animation.plays = true;

            const AdobeAn = animation.AdobeAn;
            const comp = animation.composition;
            const lib = comp.getLibrary();
            AdobeAn.compositionLoaded(lib.properties.id);

            const canvas = document.getElementById('canvas');
            const exportRoot = lib.main();
            const stage = new lib.Stage(canvas);

            function tick(event) {
                if (!animation.plays) {
                    stage.update(event);
                }
            }

            stage.addChild(exportRoot);
            createjs.Ticker.framerate = lib.properties.fps;
            createjs.Ticker.addEventListener('tick', tick);

            loader.addEventListener('complete', function(evt) {
                handleComplete(evt, animation);
                if (typeof complete === 'function') complete.call(this, animation);
            });
        }
        */
        new Promise(resolve => {
            const p = import('./canvas/main.js');
            if (p)
                p.then(anim => {
                    resolve(anim);
                });
            else resolve(null);
        }).then(anim => {
            return new Promise(resolve => {
                // console.log({anim, resolve});
                // loadAnimationResources(anim, resolve, 1);
                // console.log(anim.composition.getLibrary());
                resolve;
                /*
                const comp = anim.composition;
                const lib = comp.getLibrary();
                const exportRoot = new lib.main();

                const canvas = document.getElementById('canvas');
                canvas.width = lib.properties.width;
                canvas.height = lib.properties.height;

                const stage = new lib.Stage(canvas);
                stage.addChild(exportRoot);
                createjs.Ticker.setFPS(lib.properties.fps);
                createjs.Ticker.addEventListener('tick', stage);
                */

                const canvas = document.getElementById('canvas');
                const animContainer = document.getElementById('animation_container');
                const domOverlayContainer = document.getElementById('dom_overlay_container');
                const comp = anim.composition;
                const lib = comp.getLibrary();
                const loader = new createjs.LoadQueue(false);
                loader.addEventListener('fileload', function(evt) {
                    handleFileLoad(evt, comp);
                });
                loader.addEventListener('complete', function(evt) {
                    handleComplete(evt, comp);
                });
                loader.loadManifest(lib.properties.manifest);
                function handleFileLoad(evt, comp) {
                    const images = comp.getImages();
                    if (evt && evt.item.type === 'image') {
                        images[evt.item.id] = evt.result;
                    }
                }
                function handleComplete(evt, comp) {
                    const ss = comp.getSpriteSheet();
                    const queue = evt.target;
                    const ssMetadata = lib.ssMetadata;
                    for (let i = 0; i < ssMetadata.length; i++) {
                        ss[ssMetadata[i].name] = new createjs.SpriteSheet({images: [queue.getResult(ssMetadata[i].name)], frames: ssMetadata[i].frames});
                    }
                    const exportRoot = new lib.main();
                    const stage = new lib.Stage(canvas);

                    const fnStartAnimation = function() {
                        stage.addChild(exportRoot);
                        createjs.Ticker.setFPS(lib.properties.fps);
                        createjs.Ticker.addEventListener('tick', stage);
                    };
                    // AdobeAn.compositionLoaded(lib.properties.id);
                    function makeResponsive(isResp, respDim, isScale, scaleType) {
                        let lastW,
                            lastH,
                            lastS = 1;
                        window.addEventListener('resize', resizeCanvas);
                        resizeCanvas();
                        function resizeCanvas() {
                            const w = lib.properties.width,
                                h = lib.properties.height;
                            const iw = window.innerWidth,
                                ih = window.innerHeight;
                            const pRatio = window.devicePixelRatio || 1,
                                xRatio = iw / w,
                                yRatio = ih / h;
                            let sRatio = 1;
                            if (isResp) {
                                if ((respDim === 'width' && lastW === iw) || (respDim === 'height' && lastH === ih)) {
                                    sRatio = lastS;
                                } else if (!isScale) {
                                    if (iw < w || ih < h) sRatio = Math.min(xRatio, yRatio);
                                } else if (scaleType === 1) {
                                    sRatio = Math.min(xRatio, yRatio);
                                } else if (scaleType === 2) {
                                    sRatio = Math.max(xRatio, yRatio);
                                }
                            }
                            const resizeRatio = 0.6745;
                            canvas.width = w * pRatio * sRatio * resizeRatio;
                            canvas.height = h * pRatio * sRatio * resizeRatio;
                            canvas.style.width = domOverlayContainer.style.width = animContainer.style.width = w * sRatio * resizeRatio + 'px';
                            canvas.style.height = animContainer.style.height = domOverlayContainer.style.height = h * sRatio * resizeRatio + 'px';
                            stage.scaleX = pRatio * sRatio * resizeRatio;
                            stage.scaleY = pRatio * sRatio * resizeRatio;
                            lastW = iw;
                            lastH = ih;
                            lastS = sRatio;
                            stage.tickOnUpdate = false;
                            stage.update();
                            stage.tickOnUpdate = true;
                        }
                    }
                    makeResponsive(false, 'both', false, 1);
                    fnStartAnimation();
                    adapters.DragController().init();
                    adapters.Preloader().start();
                    adapters.HelperBlock().init();
                }
            });
        });
        /*
        const canvasPromise = new Promise(resolve => {
            import('./canvas/main.js').then(animation => {
                console.log(animation);
                
            });
        });
        */
        /*
        function handleComplete(evt, animation) {
            const AdobeAn = animation.AdobeAn;
            const comp = animation.composition;
            const lib = comp.getLibrary();

            // This function is always called, irrespective of the content. You can use the variable "stage" after it is created in token create_stage.
            AdobeAn.compositionLoaded(lib.properties.id);

            const ss = comp.getSpriteSheet();
            const queue = evt.target;
            const ssMetadata = lib.ssMetadata;

            if (queue) {
                for (let i = 0; i < ssMetadata.length; i++) {
                    ss[ssMetadata[i].name] = new createjs.SpriteSheet({ images: [queue.getResult(ssMetadata[i].name)], frames: ssMetadata[i].frames });
                }
            }
            animation.loaded = true;
        }
        function handleFileComplete(e) {
            console.log(e)
            handleComplete(e);
        }
        const preload = new createjs.LoadQueue();
        preload.addEventListener('fileload', handleComplete);
        preload.loadFile('./js/viscom/mastercard/businesscards/canvas/main.js');
        */
        // adapters.DragController().init();
        // adapters.Preloader().start();
        // adapters.HelperBlock().init();
        /*
        loadJS(this._scripts).then(() => {
            adapters.DragController().init();
            adapters.Preloader().start();
            adapters.HelperBlock().init();
        });*/
    }
}
